import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { LoaderMode, LoaderService } from '../../shared/services/loader.service';
import { HTTP_LOADER_MODE } from './loader-context';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private hasShownInitialBlocking = false;

  constructor(private loader: LoaderService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const requestedMode = req.context.get(HTTP_LOADER_MODE);
    if (requestedMode === 'none' || !this.shouldTrackRequest(req)) {
      return next.handle(req);
    }

    const mode = this.resolveMode(req, requestedMode);
    this.loader.start(mode);
    
    return next.handle(req).pipe(
      finalize(() => {
        this.loader.stop(mode);
      })
    );
  }

  private resolveMode(req: HttpRequest<any>, requestedMode: 'auto' | 'blocking' | 'background'): LoaderMode {
    if (requestedMode !== 'auto') {
      return requestedMode;
    }

    // Allow one initial blocking pass for first auth/bootstrap request only.
    if (!this.hasShownInitialBlocking && this.isBootstrapRequest(req.url)) {
      this.hasShownInitialBlocking = true;
      return 'blocking';
    }

    return 'background';
  }

  private shouldTrackRequest(req: HttpRequest<any>): boolean {
    const url = req.url.toLowerCase();
    const method = req.method.toUpperCase();

    // Track API requests only
    if (!url.includes('/api/')) {
      return false;
    }

    // Ignore preflight and static assets
    if (method === 'OPTIONS') {
      return false;
    }

    return !(
      url.includes('.js') ||
      url.includes('.css') ||
      url.includes('.html') ||
      url.includes('.ico') ||
      url.includes('/assets/')
    );
  }

  private isBootstrapRequest(url: string): boolean {
    const normalized = url.toLowerCase();
    return (
      normalized.includes('/api/users/login') ||
      normalized.includes('/api/users/register') ||
      normalized.includes('/api/countries') ||
      normalized.includes('/api/dashboard/')
    );
  }
}
